const lineHeight = value => {
  const height = parseInt(value.substring(0, value.indexOf('rem')))
  return `${height + height * 0.8}rem`
}

export default lineHeight
